<template>
  <div class="struct_tech">
    <div class="top">
      <div class="top__img">
        <img
          src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/tech_icon.png"
          width="100%"
        />
      </div>
      <div class="top__large">工程数字科技</div>
      <div class="top__small" style="margin-top:20px;">
        以5G技术、大数据、云计算等为代表的数字技术提供新型基础设施，推动现有传统基础设施进行智能化升级改造，实现土木行业智能化重塑
      </div>
    </div>
    <Breadcrumb style="margin: 20px 10%;font-size: 18px;">
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem to="/business">业务介绍</BreadcrumbItem>
      <BreadcrumbItem>工程数字科技</BreadcrumbItem>
    </Breadcrumb>
    <div class="content">
      <div v-for="item in structList" :key="item.id" class="contentBox">
        <!-- <div class="title">{{item.title}}</div> -->
        <img :src="item.image" alt="" width="100%">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'struct_tech',
  data() {
    return {
      projectList: [
        '广州市新光大桥健康监测平台开发',
        '广州市鹤洞大桥健康监测平台开发',
        '中山市地方公路桥梁健康监测平台开发',
        '佛山市顺德水道特大桥结构健康监测平台开发',
        '佛山市华阳特大桥运营期结构健康监测平台开发',
        '佛山市龙湾大桥长期健康监测平台开发',
        '大疆天空之城结构施工监控与运营健康监测平台开发',
        '广州市北环高速公路桥梁管理系统开发',
        '融合Cloud-BIM信息技术的城市基础设施集群式健康监测平台研发',
        ''
      ],
      structList: [
        {
          id: 'struct1',
          title: '工程安全监测预警平台',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_tech1.png'
        },
        {
          id: 'struct2',
          title: '工程大数据智能应用平台',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_tech2-2.png'
        },
        {
          id: 'struct3',
          title: '工程信息化管理系统',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_tech3.png'
        },
        {
          id: 'struct4',
          title: '基于计算机视觉的工程检测',
          image: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_tech4.png'
        },
      ]
    }
  },
  created() {
    this.$emit('changeProduce','struct_tech')
  },
  mounted() {
    document.body.scrollIntoView()
  }
}
</script>
<style lang="less" scoped>
.struct_tech {
  .top {
    width: 100%;
    height: 280px;
    background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/stru_tech_banner.png")
      center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #fff;
    &__img {
      width: 71px;
      height: 66px;
    }
    &__large {
      margin-top: 16px;
      font-size: 24px;
      line-height: 1.5em;
    }
    &__small {
      font-size: 16px;
      line-height: 1.5em;
    }
  }
  .content {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 64px;
    .contentBox{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px 0;
      .title {
        margin: 48px 0 50px;
        position: relative;
        font-size: 30px;
        line-height: 1.5em;
        font-weight: bold;
        color: #000;
      }
      .title::after {
        content: "";
        position: absolute;
        bottom: -8px;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 8px;
        background-color: #FAAD14;
      }
      img{
        width: 100%;
        margin: 20px 0;
      }
    }

  }
}
</style>
